import React from "react";
import { useParams } from "react-router-dom";
import { CreditListViewV2, ItemCredit } from "./CreditListView";
import { dateConverter } from "../../../../utils/dateConverter";
import { useSpendingDemandCreditList } from "../../hooks";
import { Credit } from "../../../credit/types/credit.type";
import UserInfo from "../../../user/components/UserInfo";
import EmptyListIcon from "../../../../components/atoms/EmptyListIcon/EmptyListIcon";
import Loader from "../../../../components/atoms/Loader/Loader";
import PaginationV2 from "../../../../components/organismes/PaginationV2/PaginationV2";
import { IconType } from "../../../../assets/JWayIcons";
import useNavigationApp from "../../../../navigation/hook/useNavigationApp";

export interface CreditListPresenterProps {
  spendingDemandId?: string;
  withSelectMode?: boolean;
  forUser?: boolean;
  pageSize?: number;
}

export default function SpendingDemandCreditListPresenter({
  spendingDemandId: spendingDemandIdProp,
  withSelectMode,
  forUser,
  pageSize = 10
}: CreditListPresenterProps) {
  const { spendingDemandId: spendingDemandIdParam } = useParams();
  const spendingDemandId = spendingDemandIdProp || spendingDemandIdParam || "";
  
  const { getAllQuery } = useSpendingDemandCreditList(spendingDemandId, {
    pageSize,
    disableQuery: !spendingDemandId
  });

  const { goToCredit } = useNavigationApp();

  const { data: creditListData, isLoading } = getAllQuery;
  const pagination = creditListData?.pagination;

  const handleClick = (creditId: string) => {
    // Only allow clicks for admin users (when forUser is false or undefined)
    if (!forUser) {
      goToCredit(creditId);
    }
  };

  const formated: ItemCredit[] | undefined =
    creditListData?.data?.map((credit: Credit) => {
      return {
        id: credit.credit_id,
        title: credit.credit_ref || `Crédit ${credit.credit_id}`,
        reference: credit.credit_ref,
        userFullNameRenderer: () => (
          <>
            <UserInfo id={credit.credit_user_id as any as string} info="username" limitText={10} />{" "}
            <UserInfo id={credit.credit_user_id as any as string} info="lastname" limitText={10} />{" "}
          </>
        ),
        createdDate: dateConverter(credit.credit_creation_date),
        amount: credit.credit_amount,
        status: credit.credit_available ? "Disponible" : "Utilisé",
        paymentMode: credit.credit_payment_mode || "",
        colorStatus: {
          backgroundColor: credit.credit_available ? "#E8F5E9" : "#FFF3E0",
          color: credit.credit_available ? "#2E7D32" : "#E65100",
          iconType: undefined as IconType | undefined,
        },
        withPin: false,
        onClick: !forUser ? () => handleClick(credit.credit_id) : undefined,
      };
    });

  if (isLoading) {
    return <Loader paddingTop="20%" centered />;
  }

  if (!formated) {
    return <EmptyListIcon message="Une erreur est survenue" />;
  }

  if (formated && formated.length === 0) {
    return null;
  }

  return (
    <>
      <CreditListViewV2
        creditList={formated || []}
        isCheckMode={withSelectMode}
        noUser={forUser}
      />
      {pagination && (
        <PaginationV2
          centered
          currentPage={pagination?.current_page}
          lastPage={pagination?.total_pages}
          setCurrentPage={getAllQuery.setPage}
        />
      )}
    </>
  );
}

